/**
 * @Author: v_huangyongxing@baidu.com
 * @Date: 2023-03-20 15:27:02
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-03-20 16:49:20
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageCommercialPassword.js
 * @Description: 商用密码安全合规解决方案
 */

import React from 'react';
import PropTypes from 'prop-types';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';
import './pageCommercialPassword.less';

const structureData = [
    {
        imgSrc: require('../../asset/image/pageCommercialPassword/jinrong.png'),
        title: '金融领域',
        text: '根据《金融领域国产密码改造评价指标》和《金融领域信息系统国产密码改造基线》相关要求，金融行业的核心系统、柜面系统、ATM系统、'
            + '智慧柜员机、现金柜员机、智能POS、个人手机银行、企业手机银行、直销银行、移动展业、网上银行、银企直连、中间业务系统等系统的强制按要求进行国密改造。',
    },
    {
        imgSrc: require('../../asset/image/pageCommercialPassword/dianli.png'),
        title: '电力领域',
        text: '根据《密码法》、《关键信息基础设施安全保护条例》等法律法规的明确要求，关键信息基础设施的运营者采购涉及商用密码的网络产品和服务，'
            + '可能影响国家安全的，应当按照《中华人民共和国网络安全法》的规定，通过国家网信部门会同国家密码管理部门等有关部门组织的国家安全审查。电力行业的安全性需求已上升到国家安全层级。',
    },
    {
        imgSrc: require('../../asset/image/pageCommercialPassword/zhengwu.png'),
        title: '政务领域',
        text: '随着《密码法》的颁布实施，各级政务信息系统是商用密码应用安全评估的最重要领域。政务信息系统作为民生数据信息的重点承载和应用系统，合规性是重中之重，其安全性已经上升到关乎国计民生的重要程度。',
    }
];

const proinfoData = [
    {
        imgSrc: require('../../asset/image/pageBrain/icon_jishuzhicheng.svg'),
        title: '合规性',
        text: '使用的密码算法、密码协议、密钥管理符合国家法律法规和标准规定，密码产品或服务经过国家密码管理局核准和认证机构认证合格。'
    },
    {
        imgSrc: require('../../asset/image/pageBrain/icon_yewuzhuanjia.svg'),
        title: '正确性',
        text: '密码算法、密码协议、密钥管理、密码产品或服务使用正确。即按密码相关的国家和行业标准进行正确设计和实现。'
    },
    {
        imgSrc: require('../../asset/image/pageBrain/icon_fengfu.svg'),
        title: '有效性',
        text: '密码保障系统在系统运行过程中能够发挥实际效用，保障信息系统的安全需求，解决信息系统面临的安全问题。'
    }
];


const PageCommercialPassword = props => {
    const bannerInfo = props.bannerInfo || {};

    return (
        <div className={'product Brain'}>
            <div className="pro-banner-box bg-new">
                <ProBanner
                    title={bannerInfo.title}
                    urlText={bannerInfo.urlText}
                    bgImg={bannerInfo.bgImg}
                    url={bannerInfo.url}
                />
                {bannerInfo.nextText ? (
                    <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                        {bannerInfo.nextText}
                    </a>
                ) : null}
            </div>

            <div className={'product-des'}>
                {bannerInfo.bannerNote}
            </div>

            <div className={'product-mod mt100'}>
                <ProductTitle title={'三大基本要求'} />
            </div>

            <div className={'product-mod sec-p-box'}>
                {
                    proinfoData.map(({imgSrc, title, text}, index) => {
                        return <div className={'proinfo-box mui-flex'} key={index}>
                            <div className={'proinfo-box-icon'}>
                                <img
                                    src={imgSrc}
                                    width={'100%'}
                                />
                            </div>
                            <div className={'cell'}>
                                <div className={'proinfo-box-title'}>{title}</div>
                                <div className={'proinfo-box-des'}>
                                    {text}
                                </div>
                            </div>
                        </div>;
                    })
                }
            </div>

            <div className={'product-mod'}>
                <ProductTitle title={'一站式综合服务体系'} />
            </div>

            <div>
                <img src={require('../../asset/image/pageCommercialPassword/arc.png')} alt="" width={'100%'} />
            </div>

            <div style={{background: '#F5F5F5', paddingBottom: '1rem'}}>
                <div className={'product-mod'} style={{paddingTop: '1rem'}}>
                    <ProductTitle title="方案优势" />
                </div>
                <div>
                    {
                        [
                            {
                                title: '专业性',
                                content: '加解密技术是信息安全的基石，基于密码学领域的技术积累与实践，为客户提供专业服务。'
                            },
                            {
                                title: '完整性',
                                content: '提供从咨询服务到密评服务的完整服务体系，为客户提务完善的turn-key服务。'
                            },
                            {
                                title: '多样性',
                                content: '基于百度智能云完整的生态服务能力，打通产业上下游生态，提供全国性的服务能力。'
                            }
                        ].map((item, index) => {
                            return (
                                <div key={index} className="saas-app-solution-card">
                                    <div className="title">{item.title}</div>
                                    <div className="content">{item.content}</div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>

            <div className={'product-mod mt100'}>
                <ProductTitle title={'应用场景'} />
            </div>

            <div>
                {
                    structureData.map(({imgSrc, title, text, imgWidth}, index) => {
                        return <div className={(index + 1) % 2 === 0 ? 'structure hui' : 'structure'} key={index}>
                            <div
                                className={'shadow'}
                            >
                                <div className={'imgBor'} style={{width: imgWidth ? imgWidth : '100%'}}>
                                    <img
                                        src={imgSrc}
                                        alt={title}
                                    />
                                </div>
                            </div>
                            <div className={'title'}>
                                {title}
                            </div>
                            <div className={'text'}>
                                {text}
                            </div>
                        </div>;
                    })
                }
            </div>

            <div className="saas-app-solution-contact">
                <div className="saas-app-solution-contact-inner">
                    <div className="des" style={{paddingTop: '1.2rem'}}>
                        联系我们立即获取免费技术专家咨询
                    </div>
                    <a href={bannerInfo.url} className="btn" style={{marginTop: '.76rem'}}>
                        立即咨询
                    </a>
                </div>
            </div>
        </div>
    );

};

PageCommercialPassword.propTypes = {
    bannerInfo: PropTypes.object
};

export default PageCommercialPassword;



// WEBPACK FOOTER //
// ./src/containers/product/pageCommercialPassword.js